import React, { FC } from "react";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import Page404 from "go-app/components/Page404/Page404";
import SettingsNavigation from "./components/SettingsNavigation";
import { OrganizationSettingsArchivesPage } from "./pages/Archives";
import OrganizationSettingsCompanyPage from "./pages/Company";
import OrganizationSettingsCorrectionPage from "./pages/Correction";
import OrganizationSettingsCustomFieldsPage from "./pages/CustomFields";
import OrganizationSettingsDiagnosticPage from "./pages/Diagnostic";
import OrganizationSettingsDiagnostic2Page from "./pages/Diagnostic2";
import OrganizationSettingsInvoicePage from "./pages/Invoice";
import OrganizationSettingsJpkExportPage from "./pages/JpkExport";
import OrganizationSettingsPermissionsPage from "./pages/Permissions";
import OrganizationSettingsRemoveOrganizationPage from "./pages/RemoveOrganization/Index";
import OrganizationSettingsSegmentsPage from "./pages/Segments";
import OrganizationSettingsStockPage from "./pages/Stock";
import OrganizationSettingsStocksPage from "./pages/Stocks";
import OrganizationSettingsUsersPage from "./pages/Users";

const OrganizationSettingsPage: FC<RouteComponentProps> = (props) => {
	return (
		<div className="page-container">
			<SettingsNavigation />
			<Switch>
				<Route path={`${props.match.url}/company`} component={OrganizationSettingsCompanyPage} />
				<Route path={`${props.match.url}/invoice`} component={OrganizationSettingsInvoicePage} />
				<Route path={`${props.match.url}/users`} component={OrganizationSettingsUsersPage} />
				<Route path={`${props.match.url}/permissions`} component={OrganizationSettingsPermissionsPage} />
				<Route path={`${props.match.url}/stocks`} component={OrganizationSettingsStocksPage} />
				<Route path={`${props.match.url}/stock`} component={OrganizationSettingsStockPage} />
				<Route path={`${props.match.url}/segments`} component={OrganizationSettingsSegmentsPage} />
				<Route path={`${props.match.url}/custom_fields`} component={OrganizationSettingsCustomFieldsPage} />
				<Route path={`${props.match.url}/export`} component={OrganizationSettingsJpkExportPage} />
				<Route path={`${props.match.url}/diagnostic_old`} component={OrganizationSettingsDiagnosticPage} />
				<Route path={`${props.match.url}/diagnostic`} component={OrganizationSettingsDiagnostic2Page} />
				<Route path={`${props.match.url}/correction`} component={OrganizationSettingsCorrectionPage} />
				<Route path={`${props.match.url}/archives`} component={OrganizationSettingsArchivesPage} />
				<Route
					path={`${props.match.url}/remove_organization`}
					component={OrganizationSettingsRemoveOrganizationPage}
				/>
				<Redirect from={`${props.match.url}`} exact to={`${props.match.url}/company`} />
				<Route component={Page404} />
			</Switch>
		</div>
	);
};

export default OrganizationSettingsPage;
